import React, { createContext, useContext, useState, useEffect } from 'react';

const BrandContext = createContext();

export { BrandContext }; // Export the context

export const BrandProvider = ({ children }) => {
  const [selectedBrand, setSelectedBrand] = useState(null);

  const handleBrandSelect = (brand) => {
    setSelectedBrand(brand);
  };

  useEffect(() => {
    const checkSelectedBrand = async () => {
      try {
        const response = await fetch('https://api.glowytics.com/api/brands', {
          credentials: 'include'
        });
        
        if (!response.ok) {
          setSelectedBrand(null);
          return;
        }

        const data = await response.json();
        
        if (data.brands && data.brands.length > 0) {
          setSelectedBrand(data.brands[0]);
        }
      } catch (error) {
        console.error('Error checking brand:', error);
        setSelectedBrand(null);
      }
    };

    checkSelectedBrand();
  }, []);

  return (
    <BrandContext.Provider value={{ selectedBrand, handleBrandSelect }}>
      {children}
    </BrandContext.Provider>
  );
};

export function useBrand() {
  const context = useContext(BrandContext);
  if (!context) {
    throw new Error('useBrand must be used within a BrandProvider');
  }
  return context;
} 